import type z from 'zod/v4'
import { relations, sql } from 'drizzle-orm'
import { boolean, index, integer, pgTable, text, timestamp, uniqueIndex, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { user } from '../auth'
import { Book } from '../content'

export const LoveBook = pgTable(
  'love_book',
  {
    id: uuid().primaryKey().defaultRandom(),
    userId: text().references(() => user.id, { onDelete: 'cascade' }),
    bookId: uuid()
      .references(() => Book.id, { onDelete: 'cascade' })
      .notNull(),
    calculatedMetrics: boolean().default(false).notNull(),
    calculatedForMonthlyMetrics: boolean().default(false).notNull(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true }).$onUpdateFn(() => sql`now()`),
    createdAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),

    // LEGACY
    legacyFavoriteId: integer(),
  },
  (t) => [
    index('idx_love_book_user').on(t.userId),
    index('idx_love_book_book').on(t.bookId),
    index('idx_love_book_monthly_metrics').on(t.calculatedForMonthlyMetrics),
    uniqueIndex('love_book_user_book_uidx').on(t.userId, t.bookId),
  ],
)

export const loveBookRelations = relations(LoveBook, ({ one }) => ({
  book: one(Book, {
    fields: [LoveBook.bookId],
    references: [Book.id],
  }),

  user: one(user, {
    fields: [LoveBook.userId],
    references: [user.id],
  }),
}))

export const InsertLoveBookSchema = createInsertSchema(LoveBook).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})

export const UpdateLoveBookSchema = createUpdateSchema(LoveBook).partial().omit({
  id: true,
  userId: true,
  bookId: true,
  createdAt: true,
  updatedAt: true,
})

export const SelectLoveBookSchema = createSelectSchema(LoveBook)

export type InsertLoveBook = typeof LoveBook.$inferInsert
export type UpdateLoveBook = z.infer<typeof UpdateLoveBookSchema>
export type SelectLoveBook = typeof LoveBook.$inferSelect
